/* Sãe Active — BNPL "How it works" modal.
   Loaded globally (defer) from theme.liquid. The installed apps don't inject
   storefront scripts, so instead of linking off-site we open a small on-brand
   modal explaining pay-in-4 and linking to each provider for full terms. */
(function () {
  'use strict';

  var modal = null;

  function build() {
    modal = document.createElement('div');
    modal.className = 'bnpl-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="bnpl-modal__backdrop" data-bnpl-close></div>' +
      '<div class="bnpl-modal__card" role="dialog" aria-modal="true" aria-label="Pay in 4, interest-free">' +
        '<button type="button" class="bnpl-modal__x" data-bnpl-close aria-label="Close">&times;</button>' +
        '<p class="bnpl-modal__eyebrow">Buy now, pay later</p>' +
        '<h2 class="bnpl-modal__title">Pay in 4, interest-free</h2>' +
        '<p class="bnpl-modal__body">Split your purchase into 4 payments with no interest. Choose Tabby or Tamara as your payment method at checkout and complete your plan in their secure flow.</p>' +
        '<div class="bnpl-modal__providers">' +
          '<a class="bnpl-modal__provider" href="https://tabby.ai" target="_blank" rel="noopener">' +
            '<span class="bnpl-modal__logo">tabby</span><span class="bnpl-modal__learn">Learn more</span>' +
          '</a>' +
          '<a class="bnpl-modal__provider" href="https://tamara.co" target="_blank" rel="noopener">' +
            '<span class="bnpl-modal__logo">tamara</span><span class="bnpl-modal__learn">Learn more</span>' +
          '</a>' +
        '</div>' +
        '<p class="bnpl-modal__fine">Subject to approval. See Tabby or Tamara for full terms.</p>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bnpl-close]')) close();
    });
  }

  function open() {
    if (!modal) build();
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bnpl-open]');
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
